<template>
  <div>
    <div class="activate-announcements mt-4">
      <div class="toggle-text">Activate Promotional Bar</div>
      <Toggle v-model="showAnnouncement" />
    </div>
    <div v-if="showAnnouncement" class="announcements-editor">
      <div v-if="showUpload" class="container-upload">
        <div class="top-section-container-upload">
          <div class="text" />
          <div class="image-upload" v-on:click="toggleUpload()">Type in promotion instead</div>
        </div>
        <form enctype="multipart/form-data" novalidate>
          <div class="dropbox">
            <img src="../assets/icons/upload-file-white.svg" />
            <div class="line-one">Drag and drop to upload your image</div>
            <div class="line-two">
              or
              <a>browse</a> for the file
            </div>
            <div class="line-three" v-if="fileName">
              File:
              <b>{{fileName}}</b>
            </div>
            <div class="line-three" v-if="isFailed">
              Status:
              <b>Upload failed</b>
            </div>
            <div class="line-three" v-if="isSuccess">
              Status:
              <b>Upload success</b>
            </div>
            <input
              type="file"
              :name="uploadFieldName"
              :disabled="isSaving"
              @change="filesChange"
              accept="image/*"
              class="input-file"
            />
            <p v-if="isSaving">Uploading {{ fileCount }} files...</p>
          </div>
        </form>
        <div class="upload-button-container" v-if="isSelected||isSuccess||isFailed">
          <button class="btn btn-red-outline" type="button" v-on:click="doUpload()">Update</button>
        </div>
      </div>
      <div class="top-section-container" v-if="!showUpload">
        <div class="text">Message:</div>
        <div class="image-upload" v-on:click="toggleUpload()">Upload promotion instead</div>
      </div>
      <div class="editor" v-if="!showUpload">
        <editor-content :editor="editor" />
        <div class="action">
          <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
            <div class="controls">
              <button
                :class="[ 'btn btn-link control-btn', { 'is-active': isActive.bold() } ]"
                @click="commands.bold"
              >
                <img src="../assets/icons/icon_bold.svg" alt="bold" />
                <span>Bold</span>
              </button>
              <button
                :class="[ 'btn btn-link control-btn ml-3', { 'is-active': isActive.link() } ]"
                @click="editLink"
              >
                <img src="../assets/icons/icon_link.svg" alt="link" />
                <span>Hyperlink</span>
              </button>
              <form
                class="form-inline ml-3"
                v-if="editingLink || isActive.link()"
                @submit.prevent="setLinkUrl(commands.link)"
              >
                <input type="url" class="form-control" placeholder="URL" v-model="link" />
                <button type="submit" class="btn btn-red ml-3">Add Link</button>
                <button
                  type="reset"
                  class="btn btn-link ml-3"
                  @click="removeLinkUrl(commands.link)"
                >Remove Link</button>
              </form>
            </div>
          </editor-menu-bar>
          <button class="btn btn-red-outline btn-block" type="button" @click="setAlert">
            <span class="spinner-border spinner-border-sm" role="status" v-if="isSavingAlert"></span>
            <span v-if="hasAlert">Update</span>
            <span v-else>Activate</span>
          </button>
          <p v-if="alertError" class="error">{{ alertError }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import Toggle from "../components/Toggle";
import { Bold, Link } from "tiptap-extensions";

const STATUS_INITIAL = 0,
  STATUS_SELECTED = 1,
  STATUS_SAVING = 2,
  STATUS_SUCCESS = 3,
  STATUS_FAILED = 4;
export default {
  name: "AnnouncementBar",
  data: function() {
    return {
      showAnnouncement: false,
      editor: null,
      editingLink: false,
      link: "",
      isSavingAlert: false,
      alertError: "",
      hasAlert: false,
      showUpload: false,
      uploadedFiles: [],
      uploadError: null,
      currentStatus: STATUS_INITIAL,
      uploadFieldName: "photos",
      fileName: null,
      selectedFile: null
    };
  },
  props: [],
  watch: {
    showAnnouncement: {
      immediate: false, 
      handler (showAnnouncement) {
        if (!showAnnouncement && this.hasAlert) {
          this.setAlert(true);
        }
      }
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSelected() {
      return this.currentStatus === STATUS_SELECTED;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    doUpload() {
      this.currentStatus = STATUS_SAVING;
       let reqData = new FormData();
        reqData.append('enabled', true);
        reqData.append('alert', this.editor.getHTML());
        reqData.append('image', this.selectedFile);
      axios
        .post(`/api/suites/alert/save`, reqData)
        .then(() => {
          this.isSavingAlert = false;
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch(error => {
          this.isSavingAlert = false;
          this.currentStatus = STATUS_SAVING;
          if (error.response) {
            let errorStr = "";
            if (error.response.data.error) {
              errorStr = error.response.data.error;
            } else if (error.response.data.errors) {
              errorStr =
                error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ][0];
            } else {
              errorStr = error.response.data.message;
            }
            this.currentStatus = STATUS_FAILED;
            this.alertError = errorStr;
          } else {
            this.alertError =
              "Sorry, something went wrong. Please try again later.";
          }
        });
    },
    saveUpload(file) {
      this.currentStatus = STATUS_SELECTED;
      this.selectedFile = file;
    },
    filesChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.fileName = files[0].name;
      this.saveUpload(files[0]);
    },
    toggleUpload: function() {
      this.showUpload = !this.showUpload;
    },
    editLink: function() {
      this.editingLink = !this.editingLink;
    },
    setLinkUrl: function(command) {
      command({ href: this.link });
      this.editingLink = false;
    },
    removeLinkUrl: function(command) {
      command({ href: null });
      this.editingLink = false;
    },
    setAlert: function(isDisabling) {
      this.isSavingAlert = true;
      axios
        .post(`/api/suites/alert/save`, {
          enabled: !isDisabling || isDisabling !== true ? true : false,
          alert: this.editor.getHTML(),
        })
        .then(() => {
          this.isSavingAlert = false;
        })
        .catch(error => {
          this.isSavingAlert = false;
          if (error.response) {
            let errorStr = "";
            if (error.response.data.error) {
              errorStr = error.response.data.error;
            } else if (error.response.data.errors) {
              errorStr =
                error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ][0];
            } else {
              errorStr = error.response.data.message;
            }

            this.alertError = errorStr;
          } else {
            this.alertError =
              "Sorry, something went wrong. Please try again later.";
          }
        });
    }
  },
  mounted: function() {
    axios.get("/api/suites/alert/read").then(response => {
      if (response.data.alert && response.data.alert.isEnabled == true) {
        this.showAnnouncement = true;
        this.hasAlert = true;
      }
      this.editor = new Editor({
        content: response.data.alert.alert,
        extensions: [new Bold(), new Link({ openOnClick: false })]
      });
    });
  },
  beforeDestroy() {
    // Always destroy your editor instance when it's no longer needed
    this.editor.destroy();
  },
  components: {
    EditorContent,
    EditorMenuBar,
    Toggle
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables";
.activate-announcements {
  background: #f4f4f3;
  padding: 16px 30px;
  display: flex;
  justify-content: space-between;
  .toggle-text {
    font-family: HelveticaNeue;
    font-size: 14px;
    color: #4a4a4a;
    letter-spacing: 0;
  }
  .toggle-switch {
    background: #ffffff;
    border: 1px solid #222222;
    border-radius: 10px;
    width: 40px;
    cursor: pointer;
    .knob {
      background: #d8d8d8;
      width: 18px;
      height: 18px;
      margin: 1px;
      border-radius: 10px;
      transition: all 500ms;
    }
    &.active {
      background: #ff5a5f;
      .knob {
        background: #ffffff;
        transform: translateX(100%);
      }
    }
  }
}
.announcements-editor {
  background: #f4f4f3;
  padding: 0px 30px 20px 30px;
  border-top: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;
  .container-upload {
    .top-section-container-upload {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .image-upload {
          margin-top: 16px;
        padding-left: 28px;
        position: relative;
        color: #ff5a5f;
        font-family: HelveticaNeue;
        font-size: 12px;
        &:hover {
          cursor: pointer;
          transform: scale(1.02);
        }
      }
    }
    .dropbox {
      min-height: 200px;
      position: relative;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .line-one {
        font-family: HelveticaNeue;
        font-size: 14px;
        color: #4a4a4a;
        letter-spacing: 0;
        text-align: center;
        margin-top: 14px;
      }
      .line-two {
        margin-top: 5px;
        font-family: HelveticaNeue;
        font-size: 12px;
        color: #4a4a4a;
        letter-spacing: 0;
        text-align: center;
        > a {
          position: relative;
          color: #ff5a5f;
          font-family: HelveticaNeue;
          font-size: 12px;
          &:hover {
            cursor: pointer;
            transform: scale(1.02);
          }
        }
      }
      .line-three {
        font-family: HelveticaNeue;
        font-size: 14px;
        color: #4a4a4a;
        letter-spacing: 0;
        text-align: center;
      }
    }
    .input-file {
      opacity: 0;
      width: 100%;
      height: 200px;
      position: absolute;
      cursor: pointer;
    }
    .upload-button-container{
        display: flex;
        justify-content: flex-end;
    }
  }
  .top-section-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .image-upload {
      padding-left: 28px;
      position: relative;
      &:hover {
        cursor: pointer;
        transform: scale(1.02);
      }
      &:before {
        content: "";
        width: 24px;
        height: 24px;
        position: absolute;
        top: 0;
        left: 0;
        background-repeat: no-repeat;
        background-image: url("../assets/icons/upload-file.svg");
      }
      color: #ff5a5f;
      font-family: HelveticaNeue;
      font-size: 12px;
    }
    .text {
      font-family: HelveticaNeue;
      font-size: 14px;
      color: #4a4a4a;
      letter-spacing: 0;
      padding: 15px 30px 15px 0px;
    }
  }

  .editor {
    flex-grow: 1;
    .action {
      display: flex;
      justify-content: space-between;
      button {
        margin-top: 15px;
        width: auto;
      }
      .controls {
        display: flex;
        .control-btn {
          height: min-content;
          cursor: pointer;
          &:active,
          &:focus {
            outline: none;
            box-shadow: none;
          }
          &.is-active {
            background-color: #d8d8d8;
          }
          img {
            width: 12px;
            height: 12px;
            margin-right: 4px;
          }
          span {
            font-family: HelveticaNeue;
            font-size: 11.2px;
            color: #4a4a4a;
            letter-spacing: 0;
          }
          &:hover {
            background: #d8d8d8;
            text-decoration: none;
          }
        }
        form.form-inline {
          margin-top: 15px;
          input.form-control {
            background-color: white;
          }
          button {
            margin-top: 0;
            font-size: 14px;
            height: 100%;
            &.btn-link {
              color: var(--accentColor);
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.editor {
  .ProseMirror {
    width: 100%;
    border: none;
    padding: 12px 16px;
    font-size: 14px;
    background-color: white;
    min-height: 130px;
    &:focus {
      outline: none;
    }
  }
}
</style>